"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyExpectedValues = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const system_1 = require("@mui/system");
const property_types_options_context_1 = require("../../shared/property-types-options-context");
const expected_values_options_1 = require("./shared/expected-values-options");
const get_expected_value_descriptor_1 = require("./shared/get-expected-value-descriptor");
const PropertyExpectedValues = ({ property, selectedExpectedValueIndex, setSelectedExpectedValueIndex, setAnimatingOutExpectedValue, }) => {
    const propertyTypes = (0, property_types_options_context_1.usePropertyTypesOptions)();
    return ((0, jsx_runtime_1.jsx)(system_1.Stack, { direction: "row", flexWrap: "wrap", gap: "2px 8px", children: property.oneOf.map((dataType, index) => {
            let expectedValueOption;
            if ("$ref" in dataType) {
                expectedValueOption = expected_values_options_1.expectedValuesOptions[dataType.$ref];
            }
            else if (dataType.type === "array") {
                const childrenTypes = dataType.items.oneOf.map((item) => "type" in item ? item.type : item.$ref);
                const arrayType = (0, get_expected_value_descriptor_1.getArrayExpectedValueType)(childrenTypes);
                expectedValueOption = expected_values_options_1.expectedValuesOptions[arrayType];
            }
            else {
                const selected = selectedExpectedValueIndex === index;
                const childrenTitles = Object.values(dataType.properties)
                    .map((prop) => {
                    const $ref = "items" in prop ? prop.items.$ref : prop.$ref;
                    return propertyTypes[$ref]?.title;
                })
                    .filter((title) => title !== undefined);
                return ((0, jsx_runtime_1.jsx)(material_1.Tooltip
                // eslint-disable-next-line react/no-array-index-key
                , { title: childrenTitles.join(", "), placement: "top", children: (0, jsx_runtime_1.jsx)(design_system_1.Chip, { onClick: () => {
                            setAnimatingOutExpectedValue(true);
                            setTimeout(() => {
                                setSelectedExpectedValueIndex(selected ? -1 : index);
                                setAnimatingOutExpectedValue(false);
                            }, selectedExpectedValueIndex >= 0 ? 300 : 0);
                        }, label: `${childrenTitles.length} nested properties`, variant: "outlined", sx: ({ palette }) => ({
                            backgroundColor: selected ? palette.gray[20] : "transparent",
                            [`.${material_1.chipClasses.label}`]: {
                                color: selected ? palette.gray[70] : palette.gray[60],
                            },
                        }) }) }, index));
            }
            if (expectedValueOption) {
                return ((0, jsx_runtime_1.jsx)(design_system_1.Chip
                // eslint-disable-next-line react/no-array-index-key
                , { label: expectedValueOption.title, icon: (0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { icon: {
                            icon: expectedValueOption.icon,
                        }, sx: { fontSize: "1em", mr: "1ch" } }), color: "gray", sx: {
                        [`.${material_1.chipClasses.label}`]: {
                            color: ({ palette }) => palette.gray[70],
                        },
                    } }, index));
            }
            return null;
        }) }));
};
exports.PropertyExpectedValues = PropertyExpectedValues;
